import { render } from "./ViewPeppolDocuments.vue?vue&type=template&id=10071beb&scoped=true"
import script from "./ViewPeppolDocuments.vue?vue&type=script&lang=js"
export * from "./ViewPeppolDocuments.vue?vue&type=script&lang=js"

import "./ViewPeppolDocuments.vue?vue&type=style&index=0&id=10071beb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10071beb"]])

export default __exports__